import { IsOptional, IsString, MaxLength } from 'class-validator';

export class UpdatePestControlPointInactivityLabelDto {
  @IsString()
  @IsOptional()
  @MaxLength(120)
  label?: string;
}
